import React from 'react';
import styled from 'styled-components';
import { NitroLoading } from 'nitro-components';

import UserApi from '@src/api/UserApi';
import DisableCover from '@src/components/libs/disabled';

import Container from '../../components/layouts/Container';
import Page from '../../components/layouts/Page';
import ChangePassword from './ChangePassword';
import ProfileDetails from './ProfileDetails';

const Header = styled.div`
  margin: 15px 0;
`;
const ContainerPage = styled.div`
  margin-top: 5px;
  & div {
    z-index: 0;
  }
`;

class Profile extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userLoaded: false,
      isLoading: false
    };
    this.goHome = this.goHome.bind(this);
  }

  componentDidMount() {
    this.getUser();
  }

  setLoading = status => {
    this.setState({
      isLoading: status
    });
  };

  getUser = () => {
    this.setLoading(true);
    UserApi.getUser().then(data => {
      this.setLoading(false);
      this.userLoaded(data);
    });
  };

  userLoaded = user => {
    this.setState({
      userLoaded: true,
      user
    });
  };

  goHome = () => {
    this.props.history.goBack();
  };

  render() {
    const { user, userLoaded, isLoading } = this.state;
    return (
      <Container>
        {isLoading && (
          <div>
            <DisableCover />
            <NitroLoading center screen />
          </div>
        )}

        <Page header>
          <ContainerPage>
            <Header>
              {/* <NitroHeading label="Profile" size="2" noMargin /> */}
            </Header>
            {userLoaded && <ProfileDetails {...user} />}
            {userLoaded && <ChangePassword />}
          </ContainerPage>
        </Page>
      </Container>
    );
  }
}
export default Profile;



// WEBPACK FOOTER //
// ./src/features/profile/Profile.js